import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import classes from './DragHandle.module.scss'

const DragHandle = ({ listeners, attributes, small = false }) => {
  const { t } = useTranslation()

  return (
    <span
      className={classNames(classes.handle, { [classes.small]: small })}
      title={t('certificationBuilder.curriculum.dragHint')}
      {...attributes}
      {...listeners}
    >
      <i className='fa fa-bars' aria-hidden='true' />
    </span>
  )
}

DragHandle.propTypes = {
  listeners: PropTypes.object,
  attributes: PropTypes.object,
  small: PropTypes.bool,
}

export default DragHandle
